<template>
  <v-container>
    <!--   Diálogo para Mostrar Formato de Salud     -->
    <v-dialog
        v-model="signDialog"
        max-width="600"
        scrollable
    >
      <v-card class="align-center">
        <v-card-title class="headline">
          {{$t('Firmar')}} {{$t('health_format')}}
        </v-card-title>
        <v-card-text>
          <p class="text-justify title">{{healthFormatText}}</p>
        </v-card-text>
        <v-card-actions>
            <v-row>
              <v-col>
                  {{full_name_tutor_1}}<br>
                  <v-btn
                      block
                      :loading="loading"
                      color="primary"
                      @click="uuidTutor = idTutor1, signHealthForm()"
                  >
                    {{$t('sign')}}
                  </v-btn>
              </v-col>
              <v-col>
                  {{full_name_tutor_2}}<br>
                  <v-btn
                      block
                      :loading="loading"
                      color="primary"
                      @click="uuidTutor = idTutor2, signHealthForm()"
                  >
                    {{$t('sign')}}
                  </v-btn>
              </v-col>
            </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout calign-center >
      <v-flex>
        <v-card class="elevation-5">
          <v-card-text>
            <v-layout>
              <v-flex>
                <v-card class="elevation-5">
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>
                      {{$t('unsigned_health_form')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout class="my-4" align-center justify-center fill-height>
                      <v-flex>
                        <v-card-title>
                          {{$t('estudiantes')}}
                          <v-spacer></v-spacer>
                          <v-text-field
                              clearable
                              outlined
                              v-model="search"
                              append-icon="mdi-account-search"
                              :label="$t('Buscar')"
                              single-line
                              hide-details
                          ></v-text-field>
                        </v-card-title>
                        <v-data-table
                            :headers="headersTeachers"
                            :loading="loadingDataTeachers"
                            :search="search"
                            :items="students"
                            multi-sort
                            :footer-props="{
                                itemsPerPageOptions: [
                                    {text: this.$t('todos'), value: -1}
                                ],
                                itemsPerPageText: $t('filas_por_pagina')
                            }"
                            class="elevation-1"
                            :no-data-text="$t('no_registros')"
                        >
                          <template v-slot:item.signed="{ item }">
                            <div v-if="!item.signed">
                              <v-btn
                                  block
                                   @click="idTutor1 = item.idTutor1, idTutor2 = item.idTutor2, uuidStudent = item.id,
                                   full_name_tutor_1 = item.full_name_tutor_1,
                                   full_name_tutor_2 = item.full_name_tutor_2, signDialog = true"
                                  color="primary">
                                {{$t('show')}}
                              </v-btn>
                            </div>
                            <div v-else>
                              <v-btn
                                  block
                                  disabled
                                  color="primary">
                                {{$t('signed')}}
                              </v-btn>
                            </div>
                          </template>
                          <template v-slot:no-results>
                            <v-alert type="warning">
                              {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from '@/store'
import {HTTP} from '@/main.js'


export default {
  name: "student_unsigned_format",
  data: () => ({
    headersTeachers: [],
    loadingDataTeachers: false,
    loading: false,
    search: '',
    signDialog: false,
    uuidStudent: 0,
    uuidTutor: 0,
    idTutor1: '',
    full_name_tutor_1: '',
    full_name_tutor_2: '',
    idTutor2: '',
    students: [],
    healthFormatText: ''
  }),
  created () {
    this.getHealthyFormatText()
    this.getUnsignedStudents()
  },
  beforeUpdate () {
    this.headersTeachers = [
      {
        text: this.$t('health_format'),
        align: 'left',
        sortable: true,
        value: 'signed'
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'last_name'
      }
    ]
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    computedInitialDateFormatted () {
      return this.formatDate(this.date)
    },
    computedFinalDateFormatted () {
      return this.formatDate(this.date2)
    }
  },
  methods: {
    signHealthForm () {
      this.loading = true
      HTTP.post('health/vigilant',
        {
          uuidStudent: this.uuidStudent,
          uuidTutor: this.uuidTutor
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
      })
      .then(ok => {
        this.loading = false
        console.log(ok)
        // console.log('Guard con ID = ', this.uuidStudent + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', this.$t('sign_health_form_success'))
        this.getUnsignedStudents()
        setTimeout(this.clear, 3000)
        this.signDialog = false
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    getUnsignedStudents () {
      this.loadingDataTeachers = true
      HTTP.get('student_list_signed/', {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response)
        if (response.status === 204) {
          this.students = []
        } else {
          this.students  = response.data
        }
        this.loadingDataTeachers = false
      })
      .catch(error => {
        this.loadingDataTeachers = false
        console.log(error)
      })
    },
    getHealthyFormatText () {
      HTTP.get('get_healthy_format_text/', {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response)
        this.healthFormatText = response.data[0].healthy_format_text
      })
      .catch(error => {
        console.log(error)
      })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>